export default () => {
    const nodeSelectors = {
        container: '[js-accordions="container"]',
        opener: '[js-accordions="opener"]',
        hiddenContent: '[js-accordions="hidden-content"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        let containers = jQuery(nodeSelectors.container)

        containers.each(function () {
            let container = jQuery(this)
            let items = container.find(nodeSelectors.opener).parent()
            let openers = container.find(nodeSelectors.opener)

            openers.on('click', function () {
                let item = jQuery(this).parent()

                if( !jQuery(this).parent().hasClass('accordion--active') ) {
                    items.find(nodeSelectors.hiddenContent).slideUp()
                    items.removeClass('accordion--active')

                    item.addClass('accordion--active')
                    item.find(nodeSelectors.hiddenContent).slideDown()
                } else {
                    item.find(nodeSelectors.hiddenContent).slideUp()
                    item.removeClass('accordion--active')
                }
            })
        })
    }

    return Object.freeze({
        init,
    })
}